import * as React from "react";
const Heart = (props) => (
  <svg
    width={12}
    height={10}
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.08187 1.47745L6.38214 1.8788L6.6824 1.47745C7.18237 0.809181 7.98334 0.375 8.87652 0.375C10.3924 0.375 11.6251 1.60985 11.6251 3.14045C11.6251 3.7682 11.525 4.34728 11.3512 4.88456L11.3504 4.88701C10.9334 6.20653 10.0778 7.27329 9.14965 8.07094C8.21989 8.87001 7.23897 9.3803 6.60966 9.59443L6.60965 9.5944L6.60564 9.59582C6.56276 9.61095 6.48173 9.625 6.38214 9.625C6.28254 9.625 6.20152 9.61095 6.15863 9.59582L6.15864 9.59579L6.15462 9.59443C5.5253 9.3803 4.54438 8.87001 3.61462 8.07094C2.68651 7.27329 1.83084 6.20653 1.41387 4.88701L1.41388 4.887L1.41309 4.88457C1.23926 4.34728 1.13916 3.7682 1.13916 3.14045C1.13916 1.60985 2.37189 0.375 3.88776 0.375C4.78093 0.375 5.5819 0.809181 6.08187 1.47745Z"
      fill="#969BA1"
      stroke="#969BA1"
      strokeWidth={0.75}
    />
  </svg>
);
export default Heart